import React from "react";
import { Icon,Toast,Calendar} from 'antd-mobile';
import "./marketingPerformance.scss"
import {PDscroll,pageSize} from '../../utils/index'
import {monitorLists,indexLeft} from "../../api/index"
import {getDay,getMonthStartDateAndDateRange,getWeekStartDateAndEndDateRange,_dateFormatMySelf} from '../../utils/index'
import SelectDiv from '../../components/selectDiv/selectDiv'
import {MyTable,MyTableHead,MyTableTr,MyTableTh,MyTableTd,MyTableBody} from '../../components/table/index'
export default class MarketingPerformance extends React.Component{
    constructor(props){
        super(props);
        this.state={
            numReturn:0,
            pageNumber:1,
            time:[_dateFormatMySelf(getWeekStartDateAndEndDateRange()[0]),_dateFormatMySelf(getWeekStartDateAndEndDateRange()[1])],
            timeText:`${_dateFormatMySelf(getWeekStartDateAndEndDateRange()[0])}至${_dateFormatMySelf(getWeekStartDateAndEndDateRange()[1])}`,
            dateValue:2,
            DateArray:[{
                value:1,
                name:"今日"
            },{
                value:2,
                name:"本周"
            },{
                value:3,
                name:"本月"
            }],
            partData:[],
            activePart:0,
            yck:0,
            ypq:0,
            yj:0,
            yp:0,
            listData:[]
        }
        
    }
    changeType(val){
        if(val.value==1){
            this.setState({
                time:[_dateFormatMySelf(new Date()),_dateFormatMySelf(new Date())],
                timeText:`${_dateFormatMySelf(new Date())}至${_dateFormatMySelf(new Date())}`
            })
        }else if(val.value==2){
            this.setState({
                time:[_dateFormatMySelf(getWeekStartDateAndEndDateRange()[0]),_dateFormatMySelf(getWeekStartDateAndEndDateRange()[1])],
                timeText:`${_dateFormatMySelf(getWeekStartDateAndEndDateRange()[0])}至${_dateFormatMySelf(getWeekStartDateAndEndDateRange()[1])}`
            })
        }else if(val.value==3){
            this.setState({
                time:[_dateFormatMySelf(getMonthStartDateAndDateRange()[0]),_dateFormatMySelf(getMonthStartDateAndDateRange()[1])],
                timeText:`${_dateFormatMySelf(getMonthStartDateAndDateRange()[0])}至${_dateFormatMySelf(getMonthStartDateAndDateRange()[1])}`
            })
        }
        
        this.setState({
            pageNumber:1,
            dateValue:val.value
        },()=>{
            this.getListData();
        })
    }
    openTime(){
        console.log("this........",this)
        this.setState({
            timeShow:true
        })
    }
    onConfirm(startDate,endDate){
        this.setState({
            timeShow:false,
            time:[_dateFormatMySelf(startDate),_dateFormatMySelf(endDate)],
            timeText:`${_dateFormatMySelf(startDate)}至${_dateFormatMySelf(endDate)}`
        },()=>{
            this.getListData();
        })
    }
    onCanceltime(){
        this.setState({
            timeShow:false
        })
    }
    changePart(val){
        console.log(val);
        this.setState({
            activePart:val,
            pageNumber:1
        },()=>{
            this.getListData();
        })
    }
    async getListData(){
        Toast.loading("加载中...",5000)
        let obj={
            deptId:this.state.activePart||"",
            advanceSet: 200,
            endTime: this.state.time[1],
            isAsc: "",
            pageNumber: this.state.pageNumber,
            pageSize: pageSize,
            sortType: "",
            startTime: this.state.time[0]
        }
        let res=await indexLeft(obj);
        if(res.code==0){
            Toast.hide();
            if(this.state.pageNumber==1){
                this.setState({
                    listData:res.data.dataList.records
                })
            }else{
                this.setState({
                    listData:this.state.listData.concat(res.data.dataList.records)
                })
            }
            this.setState({
                numReturn:res.data.dataList.records.length,
                
                yck:res.data.adAmount,
                cpq:res.data.skuAmount,
                yp:res.data.ypCount,
                yj:(res.data.adAmount + res.data.skuAmount).toFixed(2)
            })
        }else{
            Toast.hide();
            Toast.fail(res.msg,3)
        }
    }
    render(){
        const now = new Date();
        return(
            <div className="marketingPerformance">
                <div className="time">
                    <SelectDiv
                        noIcon={true}
                        style={{width:'29.33vw',marginRight:'12px'}}
                        model={this.state.dateValue} 
                        data={this.state.DateArray} 
                        changeType={this.changeType.bind(this)}
                    />
                    <SelectDiv  style={{flex:1}}
                                showIcon={false}
                                title={this.state.timeText}
                                type='text'
                                topDivClick={this.openTime.bind(this)}
                            />
                </div>
                <div className="type">
                    <ul>
                        {
                            this.state.partData.map((s)=>{
                                return <li onClick={()=>{this.changePart(s.deptId)}} key={s.deptId} className={this.state.activePart==s.deptId?"activePart":""}>{s.deptName}</li>
                            })
                        }
                        
                    </ul>
                </div>
                <div className="tj">
                    <p className="title">合计</p>
                    <ul>
                        <li>
                            <p>{this.state.yck||0}</p>
                            <span>预存款(元)</span>
                        </li>
                        <li>
                            <p>{this.state.cpq||0}</p>
                            <span>产品券(元)</span>
                        </li>
                        <li>
                            <p>{this.state.yj||0}</p>
                            <span>业绩(元)</span>
                        </li>
                        <li>
                            <p>{this.state.yp||0}</p>
                            <span>样品(本)</span>
                        </li>
                    </ul>
                </div>
                <div className="tableWrap">
                    <MyTable style={{width:'250%'}}>
                        <MyTableHead>
                            <MyTableTh>{"姓名"}</MyTableTh>
                            <MyTableTh>{"部门"}</MyTableTh>
                            <MyTableTh>{"客户量"}</MyTableTh>
                            <MyTableTh>{"掉客户数"}</MyTableTh>
                            <MyTableTh>{"样品券"}</MyTableTh>
                            <MyTableTh>{"产品券"}</MyTableTh>
                            <MyTableTh>{"预存款"}</MyTableTh>
                            <MyTableTh>{"营销费用"}</MyTableTh>
                            <MyTableTh>{"下单本数"}</MyTableTh>
                            <MyTableTh>{"订单业绩"}</MyTableTh>
                        </MyTableHead>
                        <MyTableBody>
                        {this.state.listData.map((s,index)=>{
                            return (
                                <MyTableTr>
                                    <MyTableTd>
                                        <span>{s.userName}</span>
                                    </MyTableTd>
                                    <MyTableTd>
                                        <span>{s.deptName}</span>
                                    </MyTableTd>
                                    <MyTableTd>
                                        <span>{s.studioCount}</span>
                                    </MyTableTd>
                                    <MyTableTd>
                                        <span>{s.loseCount}</span>
                                    </MyTableTd>
                                    <MyTableTd>
                                        <span>{s.ybCount}</span>
                                    </MyTableTd>
                                    <MyTableTd>
                                        <span>{s.cpCount}</span>
                                    </MyTableTd>
                                    <MyTableTd>
                                        <span>{s.adAmount}</span>
                                    </MyTableTd>
                                    <MyTableTd>
                                        <span>{s.yxAmount}</span>
                                    </MyTableTd>
                                    <MyTableTd>
                                        <span>{s.orderCount}</span>
                                    </MyTableTd>
                                    <MyTableTd>
                                        <span>{s.payAmount}</span>
                                    </MyTableTd>
                                </MyTableTr>
                            )
                        })}
                        </MyTableBody>
                    </MyTable>
                </div>
                <Calendar
                    visible={this.state.timeShow}
                    onCancel={this.onCanceltime.bind(this)}
                    onConfirm={(startDate,endDate)=>{this.onConfirm(startDate,endDate)}}
                    defaultDate={now}
                    
                />
            </div>
        )
    }
    componentWillReceiveProps(nextProps) {
        
        
        
    }
    async componentDidMount(){
        PDscroll('contenthome',()=>{
            this.setState({
                pageNumber:this.state.pageNumber+1
            },()=>{
                if(this.state.numReturn==pageSize){
                    
                    this.getListData();
                }else{
                    Toast.fail("暂无更多",1)
                }
                
            })
        },1)
        let res=await monitorLists({pgType: 2})
        if(res.code==0){
            
            this.setState({
                partData:res.data,
                activePart:res.data[0].deptId
            })
        }else{
            Toast.fail(res.msg,3)
        }
        this.getListData()
    }
}

